import React, { createContext, useState, useContext, useMemo, useCallback } from "react"
import PropTypes from "prop-types"

import { getCurrentWeekNumber } from "../common/utility"

const BusinessContext = createContext()

export const useBusiness = () => useContext(BusinessContext)

const DEFAULT_TIMELINE = "week"
const DEFAULT_PRIORITY = "P1"
const DEFAULT_KPI = "Incident"
const DEFAULT_CATEGORY = "Highlights"

export const BusinessProvider = (props) => {
  const { children } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isReadyToGo, setIsReadyToGo] = useState(false)
  const [timeline, setTimeline] = useState(DEFAULT_TIMELINE)
  const [year, setYear] = useState(new Date().getFullYear())
  const [value, setValue] = useState(getCurrentWeekNumber())
  const [filter, setFilter] = useState({
    TechCenter: null,
    Unit: null,
    Area: null,
    ProductService: null,
    TeamDepartment: null,
    Service: null,
    ServiceOffering: null,
  })
  const [Priority, setPriority] = useState(DEFAULT_PRIORITY)
  const [KPI, setKPI] = useState(DEFAULT_KPI)
  const [category, setCategory] = useState(DEFAULT_CATEGORY)
  const [insights, setInsights] = useState([])
  const [insightsStats, setInsightsStats] = useState({})
  const [selectedOption, setSelectedOption] = useState("")
  const [topIssues, setTopIssues] = useState([])
  const [techCenterOptions, setTechCenterOptions] = useState([])
  const [unitOptions, setUnitOptions] = useState([])
  const [areaOptions, setAreaOptions] = useState([])
  const [productServiceOptions, setProductServiceOptions] = useState([])
  const [teamOptions, setTeamOptions] = useState([])
  const [serviceOptions, setServiceOptions] = useState([])
  const [serviceOfferingOptions, setServiceOfferingOptions] = useState([])
  const [service, setService] = useState("")
  const [generatedAt, setGeneratedAt] = useState("")
  const [assignmentGroup, setAssignmentGroup] = useState(null)
  const [showService, setShowService] = useState(false)

  const resetBusinessContext = useCallback(() => {
    setIsLoading(false)
    setIsReadyToGo(false)
    setTimeline(DEFAULT_TIMELINE)
    setYear(new Date().getFullYear())
    setValue(getCurrentWeekNumber())
    setFilter({
      TechCenter: null,
      Unit: null,
      Area: null,
      ProductService: null,
      TeamDepartment: null,
      Service: null,
      ServiceOffering: null,
    })
    setPriority(DEFAULT_PRIORITY)
    setKPI(DEFAULT_KPI)
    setCategory(DEFAULT_CATEGORY)
    setInsights([])
    setInsightsStats({})
    setSelectedOption("")
    setTopIssues([])
    setTechCenterOptions([])
    setUnitOptions([])
    setAreaOptions([])
    setProductServiceOptions([])
    setTeamOptions([])
    setServiceOptions([])
    setServiceOfferingOptions([])
    setService("")
    setAssignmentGroup(null)
    setShowService(false)
  }, [])

  const contextValue = useMemo(
    () => ({
      isLoading,
      setIsLoading,
      timeline,
      setTimeline,
      year,
      setYear,
      value,
      setValue,
      filter,
      setFilter,
      KPI,
      setKPI,
      category,
      setCategory,
      insights,
      setInsights,
      isReadyToGo,
      setIsReadyToGo,
      Priority,
      setPriority,
      selectedOption,
      setSelectedOption,
      topIssues,
      setTopIssues,
      techCenterOptions,
      setTechCenterOptions,
      unitOptions,
      setUnitOptions,
      areaOptions,
      setAreaOptions,
      productServiceOptions,
      setProductServiceOptions,
      teamOptions,
      setTeamOptions,
      insightsStats,
      setInsightsStats,
      serviceOptions,
      setServiceOptions,
      serviceOfferingOptions,
      setServiceOfferingOptions,
      service,
      setService,
      resetBusinessContext,
      generatedAt,
      setGeneratedAt,
      assignmentGroup,
      setAssignmentGroup,
      showService,
      setShowService,
    }),
    [
      isLoading,
      timeline,
      year,
      value,
      filter,
      KPI,
      category,
      insights,
      isReadyToGo,
      Priority,
      selectedOption,
      topIssues,
      techCenterOptions,
      unitOptions,
      areaOptions,
      productServiceOptions,
      teamOptions,
      insightsStats,
      serviceOptions,
      serviceOfferingOptions,
      service,
      resetBusinessContext,
      generatedAt,
      assignmentGroup,
      showService,
    ],
  )

  return <BusinessContext.Provider value={contextValue}>{children}</BusinessContext.Provider>
}

BusinessProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
